module.exports = __webpack_public_path__ + "static/activefoam-89a58c599a2a40ce8a2d5464422237fe.png";